module.exports = __webpack_public_path__ + "static/OBT-Allgemeine-DSE--032a6db862c5213879e40fb455d55a38.pdf";